/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ChatMessageAttachmentFileFile
 */
export interface ChatMessageAttachmentFileFile {
  /**
   *
   * @type {string}
   * @memberof ChatMessageAttachmentFileFile
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ChatMessageAttachmentFileFile
   */
  thumbnailImageUrl?: string | null
  /**
   *
   * @type {string}
   * @memberof ChatMessageAttachmentFileFile
   */
  filename: string
  /**
   *
   * @type {string}
   * @memberof ChatMessageAttachmentFileFile
   */
  humanizedFileSize: string
}

export function ChatMessageAttachmentFileFileFromJSON(json: any): ChatMessageAttachmentFileFile {
  return ChatMessageAttachmentFileFileFromJSONTyped(json, false)
}

export function ChatMessageAttachmentFileFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChatMessageAttachmentFileFile {
  if (json === undefined || json === null) {
    return json
  }
  return {
    url: json['url'],
    thumbnailImageUrl: !exists(json, 'thumbnail_image_url') ? undefined : json['thumbnail_image_url'],
    filename: json['filename'],
    humanizedFileSize: json['humanized_file_size']
  }
}

export function ChatMessageAttachmentFileFileToJSON(value?: ChatMessageAttachmentFileFile | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    url: value.url,
    thumbnail_image_url: value.thumbnailImageUrl,
    filename: value.filename,
    humanized_file_size: value.humanizedFileSize
  }
}
